import React, { useState, useEffect } from "react";
import downloadTraineeReportIcon from "../common/static/images/trainee-report.png";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnUtils from "@date-io/date-fns";
import ViewOnlyDialog from "../common-package/ViewOnlyDialog";
import MainButton from "../common-package/MainButton";
import { downloadFile, downloadUsers } from "./trainee-report";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    padding: {
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  })
);

interface IDownloadReportProps {
  open: boolean;
  onClose: () => void;
  authenticated?: boolean;
}

interface IUser {
  id: number;
  name: string;
}

export const DownloadTraineeReport: React.FunctionComponent<
  IDownloadReportProps
> = ({ authenticated, open, onClose }) => {
  const classes = useStyles();
  const [usersData, setUsersData] = useState<IUser[]>([
    {
      id: 0,
      name: "",
    },
  ]);
  const [userId, setUserId] = useState<number>(0);
  const [to, setTo] = useState<Date | null>(() => new Date());
  const [from, setFrom] = useState<Date | null>(() => {
    const d = new Date();
    d.setDate(d.getDate() - 90);
    return d;
  });

  useEffect(() => {
    if (authenticated) {
      downloadUsers().then(setUsersData);
    }
  }, [authenticated]);

  const onUserChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    setUserId(e.target.value as number);
  };

  const onDownloadZipClick = async () => {
    const userName = usersData.filter((obj) => {
      return obj.id === userId;
    })[0].name;
    const response = await downloadFile(userId, from, to);
    if (response && !("error" in response)) {
      const element = document.createElement("a");
      element.href = URL.createObjectURL(response as Blob);
      element.download = `Trainee Report (${userName}).zip`;
      document.body.appendChild(element);
      element.setAttribute("display", "none");
      element.click();
      element.remove();
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnUtils}>
      <ViewOnlyDialog
        open={open}
        onClose={onClose}
        title="Download Trainee Report"
        iconUri={downloadTraineeReportIcon}
        maxWidth="sm"
      >
        <FormControl fullWidth className={classes.padding}>
          <InputLabel id="user">User</InputLabel>
          <Select
            id="user"
            labelId="user"
            value={userId}
            onChange={onUserChange}
          >
            {usersData.map((user: IUser) => (
              <MenuItem key={user.id} value={user.id}>
                {user.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <DatePicker
          label="From"
          value={from}
          format="MMMM dd, yyyy"
          onChange={setFrom}
          className={classes.padding}
          animateYearScrolling
          autoOk
        />
        <DatePicker
          label="To"
          value={to}
          format="MMMM dd, yyyy"
          onChange={setTo}
          className={classes.padding}
          animateYearScrolling
          autoOk
        />
        <MainButton
          text="Download Zip"
          type="submit"
          onClick={onDownloadZipClick}
          fullWidth
        />
      </ViewOnlyDialog>
    </MuiPickersUtilsProvider>
  );
};

export default DownloadTraineeReport;
